import styled from 'styled-components';
import { COLORS } from '../../shared/colours';

// eslint-disable-next-line import/prefer-default-export
export const HorizontalLine = styled.hr`
  margin: 0;
  border: 1px solid ${COLORS.darkBlue1};
  background-color: ${COLORS.darkBlue1};
`;
